import { render, staticRenderFns } from "./ProblemasAtivos.vue?vue&type=template&id=1c827c9e"
import script from "./ProblemasAtivos.vue?vue&type=script&lang=js"
export * from "./ProblemasAtivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports